export enum PollQuestionType {
  HEADER = 'header',
  QUESTION_SCALE = 'question_scale',
  QUESTION_OPEN = 'question_open',
  QUESTION_ONE_ANSWER = 'question_one_answer',
}
